module.exports = __webpack_public_path__ + "media/images/players/KOEPKA_BROOKS-e2a239d473614d066355cd9ed145daff.png";